import { configureStore } from "@reduxjs/toolkit";
import roleReducer from "./reducers/roleSlice";
import imageReducer from "./reducers/imageSlice";
import userReducer from "./reducers/localSlice";
import routeReducer from "./reducers/routeSlice";
import recruitmentReducer from 'common/redux/reducers/recruitmentSlice'
import departmentReducer from 'common/redux/reducers/departmentSlice'
import usersReducer from 'common/redux/reducers/userSlice'
import attachmentsReducer from 'common/redux/reducers/attachmentSlice'
import contactLeadReducer from 'common/redux/reducers/contactLeadSlice'
import candidateReducer from 'common/redux/reducers/candidateSlice'
import companyPolicyReducer from 'common/redux/reducers/companyPolicySlice'
import recruitmentGuideReducer from 'common/redux/reducers/recruitmentGuideSlice'
import applicationReducer from 'common/redux/reducers/applicationSlice'
import interviewReducer from 'common/redux/reducers/interviewSlice'
import dashboardReducer from 'common/redux/reducers/dashboardSlice'
import referralReducer from 'common/redux/reducers/referralSlice'
import onboardingChecklistReducer from 'common/redux/reducers/onboardingChecklistSlice'
import checklistTemplateReducer from 'common/redux/reducers/checklistTemplateSlice'


const store = configureStore({
  reducer: {
    roles: roleReducer,
    images: imageReducer,
    user: userReducer,
    route: routeReducer,
    recruitment: recruitmentReducer,
    departments: departmentReducer,
    users: usersReducer,
    companyPolicy: companyPolicyReducer,
    recruitmentGuide: recruitmentGuideReducer,
    attachments: attachmentsReducer,
    contactLead: contactLeadReducer,
    candidates: candidateReducer,
    applications: applicationReducer,
    interview: interviewReducer,
    dashboard: dashboardReducer,
    referral: referralReducer,
    onboardingChecklist: onboardingChecklistReducer,
    checklistTemplate: checklistTemplateReducer,
  },
});

export default store;
